import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Lock } from 'lucide-react';
import { toast } from 'sonner';
import { Logo } from '../components/Logo';
import { API } from '../config';

const inputStyle = { background: 'rgba(0,0,0,0.2)', border: '1px solid rgba(255,255,255,0.1)', color: '#F8FAF9' };
const cardStyle = { background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.1)' };
const playfairFont = "'Playfair Display', serif";

export const ResetPassword = () => {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { toast.error('Password tidak sama'); return; }
    if (password.length < 6) { toast.error('Password minimal 6 karakter'); return; }
    setLoading(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, new_password: password });
      toast.success('Password berhasil direset. Silakan login.');
      navigate('/login');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Gagal reset password');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6" style={{ background: '#080C0A' }}>
        <div className="rounded-2xl p-8 max-w-sm text-center" style={cardStyle}>
          <p style={{ color: '#EF4444' }} className="mb-4">Token reset tidak ditemukan di URL.</p>
          <button onClick={() => navigate('/forgot-password')} className="px-5 py-2 rounded-full font-semibold" style={{ background: '#D4AF37', color: '#080C0A' }}>
            Minta Link Baru
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-6" style={{ background: '#080C0A' }}>
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-md">
        <div className="text-center mb-8">
          <Logo size={64} animated={false} />
          <h1 className="text-3xl font-light mt-3" style={{ fontFamily: playfairFont, color: '#F8FAF9' }}>Reset Password</h1>
        </div>
        <div className="rounded-2xl p-8 backdrop-blur-2xl" style={cardStyle}>
          <form onSubmit={submit} className="space-y-5" data-testid="reset-form">
            <div>
              <label className="block text-sm mb-2" style={{ color: '#A3B8AC' }}>Password Baru</label>
              <div className="relative">
                <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5" style={{ color: '#A3B8AC' }} />
                <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6}
                  className="w-full rounded-lg pl-12 pr-4 py-3.5 outline-none" style={inputStyle}
                  placeholder="Minimal 6 karakter" data-testid="reset-password-input" />
              </div>
            </div>
            <div>
              <label className="block text-sm mb-2" style={{ color: '#A3B8AC' }}>Konfirmasi Password</label>
              <div className="relative">
                <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5" style={{ color: '#A3B8AC' }} />
                <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required minLength={6}
                  className="w-full rounded-lg pl-12 pr-4 py-3.5 outline-none" style={inputStyle}
                  placeholder="Ulangi password" data-testid="reset-confirm-input" />
              </div>
            </div>
            <button type="submit" disabled={loading}
              className="w-full rounded-full px-8 py-3.5 font-medium disabled:opacity-50"
              style={{ background: '#D4AF37', color: '#080C0A' }} data-testid="reset-submit-btn">
              {loading ? 'Memproses...' : 'Reset Password'}
            </button>
          </form>
        </div>
      </motion.div>
    </div>
  );
};
